<template>
  <div>
    <div class="transparent-black" v-if="visible" @click="onClose" />
    <div :id="key" :class="`drawer ${visible ? 'show' : 'hide'}`">
      <div class="drawer-container">
        <div class="drawer-border-top pb-4" @click="onClose">
          <div class="drawer-tap" />
        </div>
        <div class="pt-0 pa-4">
          <slot name="header" />
        </div>
        <div class="drawer-content-box pt-0 pa-4">
          <slot name="content" />
        </div>
        <!-- <div class="drawer-gradient" /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CrmDrawer",
  props: {
    visible: Boolean,
    offset: Number,
  },
  data() {
    return {
      key: `crm-drawer-${this.$vnode.key}`,
      header: {
        width: 0,
        height: 0,
      },
    };
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },
  }
};
</script>

<style scoped>
.transparent-black {
  position: fixed;
  z-index: 3;
  top: 0px;
  background-color: black;
  opacity: 0.5;
  height: 100vh;
  width: var(--max-width-app);
}

.drawer {
  position: fixed;
  z-index: 4;
  width: 100%;
  max-width: var(--max-width-app);
}

.drawer-container {
  position: absolute;
  z-index: 2;
  background: #ffffff;
  border-radius: 12px 12px 0px 0px;
  height: 90vh;
  width: 100%;
  max-width: var(--max-width-app);
}

.drawer-border-top {
  display: flex;
  align-content: center;
  justify-content: center;
  width: 100%;
}

.drawer-tap {
  width: 46px;
  height: 4px;
  background: #c4c4c4;
  border-radius: 100px;
  margin-top: 10px;
}

.drawer-content-box {
  padding: 0 16px;
  overflow: auto;
  height: var(--full-content-height);
}

.drawer-title {
  font-weight: bold;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
  color: #282c37;
}

.drawer-sub-title {
  font-weight: bold;
  font-size: 18px;
  line-height: 31px;
  letter-spacing: -0.06px;
  color: #000000;
  margin-top: 10px;
}

.drawer-information {
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #6a7180;
}

.drawer-gradient {
  height: 15%;
  position: fixed;
  bottom: 0;
  width: 100%;
  /* border: 1px solid #fc0202; */
  /* background-image: linear-gradient(
    to bottom,
    rgba(255, 0, 0, 0),
    rgb(255, 255, 255, 1)
  ); */
}

.show {
  top: 10vh;
  transition: all 0.5s ease 0s;
}

.hide {
  top: 200vh;
  transition: all 0.5s ease 0s;
}
</style>